var map = {
  "./cs.json": [
    "jC3",
    [
      "hk"
    ]
  ],
  "./en.json": [
    "Gjx",
    [
      "o1"
    ]
  ],
  "./pl.json": [
    "yv",
    [
      "wr"
    ]
  ],
  "./ru.json": [
    "XX",
    [
      "5gt"
    ]
  ],
  "./tr.json": [
    "Wb",
    [
      "w18"
    ]
  ],
  "./ja.json": [
    "Jy",
    [
      "7p"
    ]
  ],
  "./zh.json": [
    "iM",
    [
      "cf"
    ]
  ],
  "./pt-br.json": [
    "YcC",
    [
      "m1"
    ]
  ],
  "./de.json": [
    "OmR",
    [
      "4r"
    ]
  ],
  "./es.json": [
    "Sm",
    [
      "wj"
    ]
  ],
  "./fr.json": [
    "mm",
    [
      "su9"
    ]
  ],
  "./it.json": [
    "OCq",
    [
      "okg"
    ]
  ],
  "./ko.json": [
    "oeb",
    [
      "eu"
    ]
  ],
  "./pt.json": [
    "WN",
    [
      "0d"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "vP";
module.exports = __rspack_async_context;
